import { Button, Space, Tooltip, Typography } from "antd";
import ActiveUsers from "../../../components/activeUsers";
import StatusTag from "../../../components/statusTag";
import { useTaxLegalActions, useTaxLegalCase } from "../../../contexts/taxLegalCaseStore";
import _t from "../../../lang/translate";
import Icon from "../../../assets/icons/icon";
import format from "../../../utilities/formatNumbers";
import UserStore from "../../../contexts/userStore";
import { renderErrorMessage } from "../../../components/messages/errorMessage";
import { useState } from "react";
import { updateTaxLegalCase } from "../../../services/taxLegalService";

export default function TaxLegalHeadExtra() {
  const { user } = UserStore.useContainer()
  const [settingCaseHandler, setSettingCaseHandler] = useState(false)

  const {
    status,
    repairRequestedAt,
    caseHandler,
    id,
  } = useTaxLegalCase();
  const { setTaxLegalCase } = useTaxLegalActions()
  const isAlreadyCaseHandler = Number(caseHandler?.id) === Number(user?.id);

  async function setCaseHandlerToCurrentUser() {
    try {
      if (isAlreadyCaseHandler) return;
      setSettingCaseHandler(true)
      const { data } = await updateTaxLegalCase(id, { revision: { caseHandlerId: user?.id } });
      setTaxLegalCase(data)
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setSettingCaseHandler(false)
    }
  }

  return (
    <Space>
      <ActiveUsers context="taxLegal" />
      <Tooltip title={isAlreadyCaseHandler ? "Du er sagsbehandleren" : "Overtag sagen"}>
        <Button onClick={setCaseHandlerToCurrentUser} shape="circle"
          loading={settingCaseHandler}
          className={`btn-toggle-inProgress ${isAlreadyCaseHandler ? "inProgress" : ""}`}
          icon={<Icon name="hand" style={{ fontSize: 16 }} />}
        />
      </Tooltip>

      <StatusTag status={status} />
      {!!repairRequestedAt && (
        <Typography.Text type={"warning"}>
          <Tooltip title={`${_t("repairRequired")} ${format.dateAndTime(repairRequestedAt)}`}>
            <Icon name="build-outline" size="large" style={{ display: "block" }} />
          </Tooltip>
        </Typography.Text>
      )}
    </Space>
  )
}
